import React, { useEffect, useRef, useState } from 'react';
import { PostDto } from '../../../api/interfaces/Posts';
import { useLoader } from '../../../Loader/LoaderContext';
import { useNavigate } from 'react-router-dom';
import { getService, postService } from '../../../servce/ApisService';
import { API_ENDPOINTS } from '../../../api';
import { getDotColor, getStatusClass, getStatusDisName } from '../../../utility/RolesUtility';
import Pagination from '../../Portals/usersMangmnt/Pagination';
import FilterPopup from '../../Portals/Modals/FilterPopup';
import { useToaster } from '../../../Toaster/Toaster';
import AnalyticsInPosts from './AnalyticsInPosts';

type FilterType = {

  leads:string[];
  addedByLeads:number[];
  assignedTo:number[];
  statusInPosts:string[];
  serviceFilterInPosts:string[];
  featuredTypeFilter:string[];
  postType:string[];
  pitchedBy:number[],
  country:number[],
  types:string[],
  companyType:string[],
  allPost:string[],
  allEvents:string[],
  allExpiredEvents:string[]
};
interface LeadsTableProps {
  leads: PostDto[]; // Use DTO for leads prop
}
const ViewPost: React.FC = () => {
  
type SortType = {
  column: string;
  direction: number;
};
interface VehicleContent {
  status: string;
  // add other fields that exist in the objects inside content, e.g., id, title, etc.
}
  const[isFeatured,setFeatured] =useState(false);
  const [isAssigned,setIsAssigned] = useState(false);
  const [isAssignable,setIsAssignable] = useState(false);
  const [isStatus,setIsStatus] = useState(false);
  const user = {
    status: "On Hold",
    // Add other user properties if needed
  };
  const[postCount,setPostCount] =useState<any |null>();
  const [name,setName] = useState("");
  const [assignedName,setAssigedName]=useState('');
  const [addedBy, setAddedBy] = useState<any[]>([]);
  const [addedByLeads, setAddedbByLeads] = useState<any[]>([]);
  const [searchInputAddedBy, setSearchInputAddedBy] = useState('');
  const [page, setPage] = useState(0);
  const[statusValue,setstatus] =useState('');
  const [isOpenTransfer,setTransfer] =useState(false)
  const { showToast } = useToaster();
 const [tableData ,setTableData] =useState([]);
 const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalElement,setTotalElements] = useState(0);
  const [filters, setFilters] = useState<FilterType>({ leads:[],addedByLeads:[],assignedTo:[],statusInPosts:[],serviceFilterInPosts:[],featuredTypeFilter:[],postType:[],pitchedBy:[],country:[],types:[],companyType:[],allPost:[],allEvents:[],allExpiredEvents:[]});
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const {setLoading} =useLoader();
  const navigate =useNavigate();
  const [isRefreshPage,setisRefreshPage]=useState(false)
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
 const dropdownRef = useRef<HTMLDivElement | null>(null);
  const handleClickOutside = (event:any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };

  const handleStatusClick = (postId:any) => {
    console.log("Post ID:", postId);
    localStorage.setItem("postId", postId);
    setIsStatus(true);
  };
  const showData =(item:PostDto)=>{
    // addedByfilters('',item.status,item.assignedToId)
  }
  
  const [submittedData, setSubmittedData] = useState('');
  const handleChange = (selectedOption: any,data:any) => {
    console.log(data?.id,selectedOption)
    setSubmittedData(selectedOption?.value || '');
    setName('assignedToOhers')
    setAssigedName(selectedOption?.firstName)
    setIsAssignable(true);
    setstatus(data);
    console.log('isAssigned:', isAssigned,isAssignable,'isAssignable')
  };
  
  useEffect(() => {
    setFilterCount(0);
    setFilters({
      leads: [],
      addedByLeads: [],
      assignedTo: [],
      statusInPosts: [],
      serviceFilterInPosts: [],
      featuredTypeFilter: [],
      postType: [],
      pitchedBy: [],
      country: [],
      types: [],
      companyType: [],
      allPost:[],
      allEvents:[],
      allExpiredEvents:[]
    });
    fetchVehicles();
    postsCount()
  }, []);
const vendorId =localStorage.getItem('vendorId')
const postStatusList = filters.statusInPosts
const fetchVehicles = async () => {
  setLoading(true);
  let body:any;
     body={
        vendorId:vendorId,
      page:currentPage,
      search:searchQuery,
      isAllData: filters.allPost?.includes("isAllPost") || filters.allEvents?.includes("isAllPost") || filters.allExpiredEvents?.includes("isAllPost") || false,
        // isAllData: filters.allPost?.includes("isAllPost") || false,
      postStatusList: postStatusList,
      // filters.statusInPosts?.filter((status) => status !== "isAllPost") ||   [],
      serviceList:filters.serviceFilterInPosts.length > 0 ? filters.serviceFilterInPosts : [],
      featuredTypeList:filters.featuredTypeFilter.length > 0 ? filters.featuredTypeFilter:[],
      postTypeList:filters.postType.length >0 ? filters.postType:[],
      addedByIds:filters?.addedByLeads?.length > 0 ? filters.addedByLeads.map(Number):[],
      assignedToId: filters?.assignedTo?.length > 0 ? Number(filters.assignedTo[0]) : null
    }
  try {
    let url:any;
    const response = await postService(API_ENDPOINTS.getDashbaordPosts,body);
    setTableData(response.data.content);
    setTotalPages(response.data.totalPages);
    setTotalElements(response.data.totalElements)
    setTimeout(() => {
      setLoading(false)
    }, 1000);
  } catch (error) {
    showToast('error', 'error','');
    setTimeout(() => {
      setLoading(false)
    }, 1000);
    console.error('Error fetching vehicle data:', error);
  }
  finally{
   
  }
};
useEffect(() => {
    fetchVehicles();
    postsCount()
   
    if (Object.keys(filters).length > 0) {
      let count = 0;
      Object.values(filters).forEach((filter) => {
        count += filter.length;
      });
      setFilterCount(count);
      fetchVehicles();
    }
    if (isRefreshPage) {
      fetchVehicles(); // Refresh data if triggered
      setisRefreshPage(false); // Reset the refresh trigger
    }
     document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
  }, [currentPage, searchQuery,filters,isRefreshPage]);
  
const onPageChange = async (page: number) => {
  setCurrentPage(page)
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };


const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
  setSearchQuery(event.target.value);
  setCurrentPage(0);
};
const postsCount = async () => {
  try {
    let url: string;
   url=API_ENDPOINTS.ClientpostCount
    const response = await getService(url+"?vendorId="+vendorId);
    setPostCount(response.data); // Update the post count with the fetched data
  } catch (error) {
    console.error("Error fetching post count:", error);
  }
};
const handleEdit = (data: any) => {
  navigate('/activateDashboard/contentMarketing/createPost?appUserId=' + data?.id);
};

const getCategory : Record<string,string>={
  IUI:'IUI',
  IVF:'IVF',
  HOSPITAL:'Hospital',
  SURROGACY_CENTER:'Surrogacy Center',
  ICSI:'ICSI',
  SPERM_OR_EGG_FREEZING:'Sperm/ Egg freezing',
}
const getType : Record<string,string>={
  ARTICLE:'Article',
  NEWS:'News'
}
const viewPost =(data:PostDto) =>{
  navigate('/vendorDashboard/activateDashbord/contentMarketing/viewPost?appUserId='+data.id)
}

  return (
    <div className="h-full py-2 w-full relative md:px-8">
      <div className='py-4'>
      <AnalyticsInPosts postCount={postCount} />
      </div>
      <div className='flex items-center mb-3 mt-2 cursor-pointer justify-between'>
        <div className='flex items-center'>
        <>
        <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F] mr-3">
         Posts
        </h1>
        <input type='text'  placeholder='Search for title or author' className='p-2 border border-[#D1D5DB] w-[300px] rounded-md' onChange={handleSearch} />
        </>
        </div>
        <div className='flex items-center '>

        
      
        
        
        {/* <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4'><span className='mr-2'>+</span>Add Post</div> */}
        
        </div>
      </div>
     
      <div className="overflow-x-auto scroolCls w-full">
  <table className="min-w-full bg-white border border-gray-200">
    <thead className="bg-gray-100 text-left">
      <tr>
        <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky left-0 bg-gray-100 z-20 w-[500px]">
          Title
        </th>
        <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">Author</th>
        <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">Category</th>
        <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">Date Published</th>
        <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs">Status</th>
      </tr>
    </thead>
    <tbody>
      {tableData.map((user: PostDto, index: number) => (
        <tr key={index}>
          <td className="px-4 py-3 border-b text-sm text-gray-900 sticky left-0 bg-white font-semibold z-10 cursor-pointer w-[500px] " onClick={()=>viewPost(user)}>
            {user?.title || 'NA'}
          </td>
          <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white whitespace-nowrap">{user?.authorName || 'NA'}</td>
          <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white whitespace-nowrap">{getCategory[user?.category] || 'NA'}</td>
          <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white whitespace-nowrap">{user?.publishedOn || 'NA'}</td>
          
          <td className="px-4 py-3 border-b text-sm text-gray-500 whitespace-nowrap w-[150px]">
            <div className="flex justify-end items-center">
              <span onClick={() => handleStatusClick(user.id)} className="cursor-pointer">
                <span className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClass(user.status)}`}>
                  <span className="inline-block w-2 h-2 mr-2 rounded-full" style={{ backgroundColor: getDotColor(user.status) }}></span>
                  {getStatusDisName(user?.status)}
                </span>
              </span>
              {(user?.isEditable && user?.status === 'SAVED_AS_DRAFT') &&
                     <img
                       src="/images/threeDot.svg"
                       alt="Menu1"
                       className="cursor-pointer ml-5"
                       onClick={() => toggleDropdown(index)}
                     />
              }
                    {activeDropdown === index && userInfo?.roles !== 'PUBLISHER'  && (
                       <div ref={dropdownRef} className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 ==">
                         <div className="py-2">
                          {/* {user.isEditable && ( */}
                            <span className='flex px-4 cursor-pointer' onClick={() => handleEdit(user)}>
                              <img src='/images/editIcon.svg' alt="Edit" />
                              <a href="#" className="ml-2 block py-2 text-sm text-[#374151] font-normal">
                                Edit
                              </a>
                            </span>
                          {/* )} */}
                          
                            {/* <span className='flex px-4 cursor-pointer' onClick={() => handleDelete(user)}>
                              <img src='/images/delete_icon.svg' alt="Edit" />
                              <a href="#" className="ml-2 block py-2 text-sm text-primary-color font-normal">
                                Delete
                              </a>
                            </span> */}
                         </div>
                       </div>
                     )}
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>

  {!tableData.length && <p className="text-center p-2 bg-white">No data to display</p>}

  {totalPages > 1 && (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      totalElement={totalElement}
      onPageChange={onPageChange}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  )}
   {/* {isFilterPopupOpen && (
        <FilterPopup applyFilters={(filters) => { setFilters(filters); setIsFilterPopupOpen(false); setCurrentPage(0);}}
          filters={filters} nameOfScreen='posts' screen=''  />
      )} */}
</div>

      
        </div>
        
  );
};
export default ViewPost
